import { getDimensionsForFormat } from "../../app/19_JetpackConfig/components/POSAEditor/helpers";
import { jsPDF } from "jspdf";
import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";

export async function generatePDFFromPNG(
  pngUrl: string,
  format: POSA_FORMAT
): Promise<jsPDF> {
  return generatePDFInner(pngUrl, format);
}

export async function generatePDFInner(
  pngUrl: string,
  format: POSA_FORMAT
): Promise<jsPDF> {
  const response = await fetch(pngUrl);
  const blob = await response.blob();

  const imageDataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const [millimeterWidth, millimeterHeight] = getDimensionsForFormat(format);

  const orientation =
    millimeterWidth > millimeterHeight ? "landscape" : "portrait";

  const pdf = new jsPDF({
    orientation,
    unit: "mm",
    format: [millimeterWidth, millimeterHeight],
    compress: false,
    putOnlyUsedFonts: true,
    floatPrecision: 16
  });

  pdf.addImage(
    imageDataUrl,
    "PNG",
    0,
    0,
    millimeterWidth,
    millimeterHeight,
    undefined,
    "FAST"
  );

  return pdf;
}
